import React, { useRef, useState } from "react";
import { Redirect } from 'react-router';
import { MultipleServices } from "../../dumb/services/MultipleServices";
import { ServiceSelector } from '../utils/images-loader/ServiceSelector';

export class MultipleServicesContainer extends React.Component<any, any> {

    constructor(props: any) {

        super(props);

        this.state = {
            // contents: Array<Object>()
            contents: Object(),
            refresh: props.refresh,
            myLoader: Object()
        }
        
        
    }

    getSnapshotBeforeUpdate = () => {

        // console.log("before update")
        // return null
    }

    // shouldComponentUpdate = () => {

    //     // if (this.state.refresh) {
    //     //     return true;
    //     // }
    //     // return false;
    // }

    componentDidUpdate = () => {

        // console.log("did upadate")
        // if(this.state.contents)
        // fetch(`api/jsonFiles/contents/${this.props.language}/${this.props.filename}.json`)
        // .then(response => response.json())
        // .then(data => {
        //     // console.log("data " + data)
        //     //console.log(data, typeof data)
        //     // 
        //     this.setState({ refresh: false })
        //     this.setState({ contents: data })
        // })
        // return null;
    }

    componentDidMount = () => {

        console.log("did mount ", this.props.filename)
        //this.setState({ title: this.props.title })
        let str = this.props.filename.replace(/\s/g, "");

        console.log("did mount ", str)
              
        fetch(`api/jsonFiles/contents/${this.props.language}/${str}.json`)
                .then(response => response.json())
                .then(data => {
                    // console.log("data " + data)
                    //console.log(data, typeof data)
                    this.setState({ myLoader: ServiceSelector.select(this.props.filename) })
                    this.setState({ contents: data })
                    //console.log(this.state.myLoader)
                })
            
        
        return null;
    }

    componentWillUnmount = () => {
        this.props.history.goForward();
        console.log("will unmount", this.props.filename)
        // console.log(this.state.refresh)
        // this.setState({ refresh: true })
    }

    render = () => {
        return (
            <div id="homeless-container">
                {this.props.redirect ? (
                    <Redirect push to="/home" />
                ) : (
                        
                        <MultipleServices contents={this.state.contents} filename={this.props.filename} myLoader={this.state.myLoader} clickhandler={this.props.clickhandler} />
                    )}
            </div>
        );
    }
}